export const CIRCLE = 'Circle'
export const SQUARE = 'Square'
export const SPIKE = 'Spike'
export const TRIANGLE = 'Triangle'
export const HIGHLIGHT = 'Highlight'
